<template>
  <div>
    <div class="campaign-header">
      <div class="container">
        <div class="flex">
          <img
            src="../../assets/img/logo.svg"
            alt="Ludimos"
          >
        </div>
      </div>
    </div>
    <div class="container">
      <div class="campaign-hero">
        <svg
          class="hero-svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 310 350"
        >
          <path
            d="M156.4,339.5c31.8-2.5,59.4-26.8,80.2-48.5c28.3-29.5,40.5-47,56.1-85.1c14-34.3,20.7-75.6,2.3-111  c-18.1-34.8-55.7-58-90.4-72.3c-11.7-4.8-24.1-8.8-36.8-11.5l-0.9-0.9l-0.6,0.6c-27.7-5.8-56.6-6-82.4,3c-38.8,13.6-64,48.8-66.8,90.3c-3,43.9,17.8,88.3,33.7,128.8c5.3,13.5,10.4,27.1,14.9,40.9C77.5,309.9,111,343,156.4,339.5z"
          />
        </svg>
        <div class="flex">
          <div class="into-text">
            <h1>NEVER MISS ANY ACTION!</h1>
            <h3>Follow your child’s development using Ludimos</h3>
            <br>
            <!-- <h1>Your child’s AI-driven cricket development journal</h1> -->
            <p>
              Your child can upload all of their training footage. Ludimos gives you key actions automatically highlighted. Your child can learn from the best, to train smarter and develop faster.
              You can now follow their journey wherever they train!
            </p>
            <div class="call-to-action-form">
              <b-form-input
                id="email-live"
                v-model="email"
                type="email"
                placeholder="Email address"
              />
              <b-form-invalid-feedback id="email-live-feedback">
                Enter
              </b-form-invalid-feedback>
              <b-form-input
                id="input-live"
                v-model="password"
                type="password"
                placeholder="Password"
              />
              <!-- <b-form-invalid-feedback id="input-live-feedback">
                Enter at least 6 letters
              </b-form-invalid-feedback> -->
              <div class="tc-wn">
                <b-form-checkbox
                  id="terms-and-conditions"
                  v-model="terms_accepted"
                  name="terms-and-conditions"
                  unchecked-value="not_accepted"
                >
                  I accept the
                  <router-link to="/general-terms-and-conditions">
                    Ludimos Terms &amp; Conditions
                  </router-link>
                </b-form-checkbox>
                <!-- <b-form-checkbox
                  id="weekly-newsletter"
                  v-model="newsletter_optin"
                  name="weekly-newsletter"
                  unchecked-value="not_accepted"
                >
                  I want to recieve newsletters
                </b-form-checkbox> -->
              </div>
              <button
                class="primary-button primary"
                @click="submit"
              >
                Start your free trial
              </button>

              <div class="rating">
                <p>"Rated 5/5 from +500 users"</p>
                <span class="material-icons"> star </span><span class="material-icons"> star </span><span class="material-icons"> star </span><span class="material-icons"> star </span><span class="material-icons">
                  star
                </span>
              </div>
            </div>
          </div>
          <img
            src="../../assets/img/campaign/b2c-hero-2.png"
            alt=""
            :style="{ width: '600px', 'max-height': '600px' }"
          >
        </div>
        <div class="social-proof flex">
          <p>Useb by:</p>
          <img
            src="../../assets/img/kncb.png"
            alt="KNCB"
          >
          <img
            src="../../assets/img/cricket-denmark.jpg"
            alt="cricket denmark"
          >
          <img
            src="../../assets/img/northerns-cricket-union.jpg"
            alt="Northerns cricket union"
          >

          <img
            src="../../assets/img/titans.jpg"
            alt="The titans"
          >
          <img
            src="../../assets/img/The-Cricket-Academy.png"
            alt="The Cricket Academy"
          >
          <img
            src="../../assets/img/Claremont-School.png"
            alt="Claremont School"
          >
          <img
            src="../../assets/img/Cricket-Mentoring.png"
            alt="Cricket Mentoring"
          >
        </div>
      </div>
    </div>

    <div
      class="section-background primary auto-height no-padding-mobile features"
    >
      <div class="container">
        <div class="campaign-main">
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <h2>Automatic highlights of your shots and balls.</h2>
              <p>
                Reviewing training footage can be time consuming at times and
                hence we developed Ludimos-AI to automatically highlight all
                your key actions. Coloured markers help you easily localise
                actions in a video. Simply turn Ludimos-AI ON to watch only
                highlights and save your valuable time from watching meaningless
                frames. Ludimos AI = Time saving + Efficiency
              </p>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="content">
                <img src="../../assets/img/campaign/campaign-image-1.png">
              </div>
              <!-- <img
                src="https://via.placeholder.com/500x300"
                alt=""
              > -->
            </div>
          </div>
          <hr>
          <div class="row flex-row-reverse">
            <div class="col-xs-12 col-md-6">
              <h2>Drills with step-by-step instructions to better your game</h2>
              <p>
                Practice makes it perfect! And your kid needs to practice a full
                10,000 times to gain muscle memory. Even elite players go back
                to basics both when they learn something new or when things
                don’t go their way. Knowing what works best for your kid is
                easy, but understanding why is difficult. Hence we are on
                mission to bring you the best of drills in simplified
                step-by-step instructions for you to understand and assist
                effectively.
              </p>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="content">
                <img src="../../assets/img/campaign/campaign-image-2.png">
              </div>
            </div>
          </div>
          <SignupForm
            title="Start your cricket journal"
            cta="Start your free trial"
            type="center"
          />

          <div class="row">
            <div class="col-xs-12 col-md-6">
              <h2>Smart video analysis & notes</h2>
              <p>
                Analyse and take notes using Text, Audio and Drawing tools.
                Every cricket coach asks their players to log their learnings,
                emotions, thoughts in a journal after every practice session and
                after every match. Only a few actually use journals and their
                data. The main reason for this is the difficulty in accessing
                the logged data and the limitation of what you can log in a
                journal. Ludimos makes it extremely easy to pick any frame from
                their video, log their thoughts using our Drawing, Audio and
                Text tools. A simple and easy way to take visual notes which
                will stay on your kids profile forever and can be accessed on
                demand by coaches.
              </p>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="content">
                <img src="../../assets/img/campaign/campaign-image-3.png">
              </div>
            </div>
          </div>
          <hr>
          <div class="row flex-row-reverse">
            <div class="col-xs-12 col-md-6">
              <h2>Weekly masterclasses</h2>
              <p>
                Your child needs guidance on drills, techniques, fitness and
                mental aspects of the game. Training skills alone is not
                sufficient. Hence we organise online masterclass with world
                renowned coaches on several areas of cricket. We send out
                information to your kids via email at the right time to empower
                them with right information. Our Masterclasses can be weekly
                emails with information and routines and monthly online calls
                with coaches.
              </p>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="content">
                <img src="../../assets/img/campaign/campaign-image-4.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-background auto-height testimonials">
      <div class="container">
        <h2>
          User testimonials
        </h2>
        <div class="custom-grid">
          <Testimonials
            testimonial="I really love the Ludimos app. It is so easy even my mom can use it. It is a great way to track all your stats and progress."
            image-src="user-8.jpg"
            alt-text="Xander Venter"
            name="Xander Venter"
            role="Notherns U13 Framework Squad"
          />
          <Testimonials
            testimonial="I have really put in the hard yards during COVID and practiced hard using Ludimos. I will be the best player I am using Ludimos"
            image-src="user-5.jpg"
            alt-text="Riaan Boshoff"
            name="Riaan Boshoff"
            role="Notherns U12 Framework Squad"
          />
          <Testimonials
            testimonial="We are really loving the app and how Ashton has improved over the last few weeks. We can really see the difference. He is more than happy to spend hours and hours in the nets practising the same drill over and over again to perfect it."
            image-src="user-10.jpg"
            alt-text="Emma Charles"
            name="Emma Charles"
            role="Mother of Ashton, Lancashire, UK"
          />
          <Testimonials
            testimonial="Ludimos is a easy app to uplaod videos to and allows to me to get some really detailed feedback that allows me to progress my game."
            image-src="user-9.jpg"
            alt-text="Ashton Charles"
            name="Ashton Charles"
            role="Lancashire, UK"
          />
          <!-- 
          <Testimonials
            testimonial="I really enjoy using Ludimos. It is simple to setup and easy to use. My favorite feature is that I can analyse my own technique at my own time from training videos."
            image-src="user-6.jpg"
            alt-text="Robyn Searle"
            name="Robyn Searle"
            role="Northerns Senior Women Cricketer"
          />
       
          <Testimonials
            testimonial="It helped me to identify the areas to improve on my batting. Ludimos is an easy to use app and it keeps every thing organised in one place."
            image-src="user-2.jpg"
            alt-text="Danelle Oberholtzer"
            name="Danelle Oberholtzer"
            role="Northerns Senior Women Cricketer"
          />
          <Testimonials
            testimonial="It helps you become more responsible for your own growth and your game. It is really great to see your progress over time. I highly recommend it."
            image-src="user-4.jpg"
            alt-text="Gandhi Jafta"
            name="Gandhi Jafta"
            role="Northerns Senior Women Cricketer"
          />
          <Testimonials
            testimonial="I can easily work with my coach remotely and able to easily identify my strengths and also key areas to improve."
            image-src="user-1.jpg"
            alt-text="Callum Croom"
            name="Callum Croom"
            role="Notherns U15 Framework Squad"
          />
         <Testimonials
            testimonial="Because of Ludimos I became a strong middle order batsman that can score the needed 30 runs and secure the win for the team. I highly recommend using Ludimos. It is very easy to use."
            image-src="noah.jpg"
            alt-text="Noah de Roos"
            name="Noah de Roos"
            role="U17 Bloemendaal Cricket Club"
          /> -->
        </div>
      </div>
    </div>
    <div class="container">
      <SignupForm
        title="Start your cricket journal"
        cta="Start your free trial"
        type="bottom"
      />
    </div>
    <div class="campaign-footer section-background primary auto-height">
      <div class="foot-note">
        <p>©2020 Ludimos | All rights reserved</p>
        <router-link to="/software-license-agreement">
          Software license Agreement
        </router-link>
        <router-link to="/general-terms-and-conditions">
          Ludimos Terms &amp; Conditions
        </router-link>
        <router-link to="/privay-policy">
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Testimonials from "./components/Testimonials";
import SignupForm from "./components/SignupForm";
import AuthService from "@/services/auth";
import SIB from "@/services/SendInBlueService";
export default {
  name: "ParentLandingPage",
  components: {
    Testimonials,
    SignupForm,
  },
  data() {
    return {
      email: "",
      password: "",
      terms_accepted: false,
      newsletter_optin: true,
    };
  },
  methods: {
    redirect() {
      // this.trackEvent(
      //   "CompleteRegistration",
      //   "CompleteRegistration",
      //   "signup",
      //   "success",
      //   "main_cta",
      //   ""
      // );
      this.$ma.trackEvent({
        fb_event: "CompleteRegistration",
        category: "CompleteRegistration",
        action: "signup",
        label: "main_cta",
        type: "main_cta",
      });
      this.$gtm.trackEvent({ 
        event: "CompleteRegistration",
        category: "CompleteRegistration",
        action: "signup",
        label: "main_cta",
        value: "0",
       })
      SIB.createContact({ email: this.email }, [243]);
      window.open(
        `${process.env.VUE_APP_APP_BASE_URL}/user-verification?email=${this.email}`
      );
    },
    async submit() {
      if (!this.email || !this.validEmail(this.email)) {
        this.$bvToast.toast("Please enter a valid email address.", {
          title: "Invalid email",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }
      if (!this.password || this.password.length < 6) {
        this.$bvToast.toast("Password should be at least 6 characters.", {
          title: "Password error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }
      // console.log('Terms: ', this.terms_accepted)
      if (!this.terms_accepted) {
        this.$bvToast.toast("Please accept our Terms & Conditions", {
          title: "T&C Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
        return;
      }
      // console.log('Sign up: ', this.terms_accepted)
      const response = await AuthService.signup(
        this.email,
        this.password,
        this.terms_accepted,
        this.newsletter_optin,
        this.$route.query
      );
      if (response.status === 201) {
        this.redirect();
        this.email = "";
        this.password = "";
        this.terms_accepted = false;
        this.newsletter_optin = false;
      } else {
        this.$bvToast.toast("Error while signing you up! Try again later.", {
          title: "Signup Error",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
          autoHideDelay: "3000",
        });
      }
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Welcome to Ludimos`, 25),
    };
  },
};
</script>
<style lang="scss" scoped>
.hero-svg {
  position: absolute;
  max-width: 100%;
  width: 700px;
  z-index: -1;
  top: 80px;
  fill: rgba(#6f44ff, 0.07);
  left: 0;
  animation: move 45s ease-in-out infinite;
  transform-origin: 50% 50%;
}

@keyframes move {
  0% {
    transform: scale(1) translate(10px, -20px) rotate(0);
  }
  20% {
    transform: scale(0.8) translate(20px, -10px) rotate(10deg);
  }
  40% {
    transform: scale(0.9) translate(10px, -20px) rotate(-10deg);
  }
  60% {
    transform: scale(1) translate(20px, -10px) rotate(10deg);
  }
  80% {
    transform: scale(0.9) translate(14px, -20px) rotate(10deg);
  }
  100% {
    transform: scale(1) translate(10px, -20px) rotate(0);
  }
}

.tc-wn {
  margin: 20px 0;
  .custom-control {
    margin-bottom: 10px;
  }
}
.rating {
  margin-top: 30px;
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    margin-bottom: 0;
    margin-right: 10px;
  }
  span {
    color: #e4c609;
    font-size: 24px;
  }
}
hr {
  border-top: 1px solid rgba($color: #fff, $alpha: 0.1);
  padding: 20px 0;
}
.testimonials {
  padding-bottom: 0;
}

.features {
  padding-bottom: 50px;
}

img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.into-text {
  padding-top: 70px;
  h1 {
    font-size: 50px;
  }
}

.campaign-header {
  background: #f7f4ff;
  padding: 10px 0;
  img {
    max-height: 40px;
    opacity: 0.5;
  }
}
.campaign-hero {
  margin: 50px 0;
}
.into-text {
  .call-to-action-form {
    input {
      margin: 20px 0;
      max-width: 300px;
    }
  }
}
.social-proof {
  margin: 40px 0;
  align-items: center;
  justify-content: center;
  img {
    max-width: 80px;
  }
  * {
    margin: 0 20px;
  }
  p {
    margin: 0;
  }
}
.campaign-main {
  .row {
    margin: 0 0 50px 0;
  }
  .inline-cta {
    margin: 50px 15px;
  }
}

.campaign-footer {
  text-align: center;
  font-size: 12px;
  padding: 40px 0;
  p {
    margin-bottom: 10px;
    font-size: 14px;
  }
  a {
    font-weight: normal;
    color: #fff;
  }
}
.customer-feedback .image img {
  width: 100px;
  height: 100px;
}
.custom-grid {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media (max-width: 767px) {
  .into-text {
    padding: 0;
    h1 {
      font-size: 50px;
    }
  }

  .flex {
    display: block;
    &.image {
      display: flex;
    }
  }
  img {
    max-width: 100%;
  }
  .call-to-action-form {
    margin-bottom: 50px;
  }
  .campaign-header {
    text-align: center;
  }
  .social-proof {
    text-align: center;
    * {
      margin: 10px;
    }
  }
  .no-padding-mobile {
    padding: 5px 0;
  }
  .campaign-main {
    .row {
      h2 {
        margin: 20px 0 5px;
      }
    }
  }
  .campaign-footer a {
    display: block;
  }

  .custom-grid {
    display: block;
  }
  .flex-row-reverse {
    flex-direction: row !important;
  }
  hr {
    padding: 0;
  }
}
</style>
